module.exports = __webpack_public_path__ + "static/media/Step2.742186f8.svg";